import { Link, Switch, Route, Redirect, useLocation } from "react-router-dom";
import { Card, Breadcrumb } from "react-bootstrap";
import BreadcrumbLink from "~/shared/BreadcrumbLink";
import ErrorBoundary from "./ErrorBoundary";
import ErrorFallback from "./ErrorFallback";

function Dashboard({ root, sections, columnSize = "200px", columns = 2 }) {
    const currentSection = useCurrentSection(root, sections);
    const gridStyle = {
        "--gap-count": `calc(${columns} - 1)`,
        "--total-gap-width": "calc(var(--gap-count) * 0.75rem)",
        "--grid-item-max-width": `calc((100% - var(--total-gap-width)) / ${columns})`,
        gridTemplateColumns: `repeat(auto-fill, minmax(max(${columnSize}, var(--grid-item-max-width)), 1fr))`
    };

    return (
        <div className={`dashboard portal-container ${currentSection?.large ? "large" : ""}`}>
            <h1 className="portal-header mb-0">{currentSection?.title ?? "Select Task"}</h1>
            <ErrorBoundary fallback={<ErrorFallback />}>
                {currentSection && <div className="w-fit mx-auto">
                    <Breadcrumb className="mt-1 mb-2">
                        <BreadcrumbLink href={`${root}/dashboard`}>Dashboard</BreadcrumbLink>
                        <Breadcrumb.Item active>{currentSection.title}</Breadcrumb.Item>
                    </Breadcrumb>
                </div>}
                <Switch>
                    {sections.map(section => (
                        <Route key={section.path} exact path={`${root}/${section.path}`} component={section.component} />
                    ))}
                    <Route exact path={`${root}/dashboard`}>
                        <section className="d-grid p-3 gap-3" style={gridStyle}>
                            {sections.map(section => (
                                <Link key={section.path} to={section.path} className="w-full" style={section.fill ? { gridColumn: "1 / -1" } : {}}>
                                    <Card>
                                        <Card.Body className="p-2">
                                            <Card.Title>{section.title}</Card.Title>
                                            <Card.Text className="text-muted mx-0">{section.description}</Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            ))}
                        </section>
                    </Route>
                    <Route>
                        <Redirect to={`${root}/dashboard`} />
                    </Route>
                </Switch>
            </ErrorBoundary>
        </div>
    );
}

function useCurrentSection(root, sections) {
    const { pathname } = useLocation();
    return sections.find(s => `${root}/${s.path}` === pathname);
}

Dashboard.useCurrentSection = useCurrentSection;
export default Dashboard;